import React from 'react'
import Dashboard from './views/pages/Dashboard/Dashboard'
import Message from './views/pages/MessageModule/Messages'
import progressNote from './views/pages/ProgressNote/ProgressNote'

const CensusScreen = React.lazy(() => import('./components/common/CommonScreen/CensusScreen'))
const EncountersScreen = React.lazy(() => import('./views/pages/Encounters/components/Main'))
const ProviderHoldScreen = React.lazy(() => import('./views/pages/ProviderHold/ProviderHoldScreen'))
const newEncounter = React.lazy(() => import('./components/NewEncounter/AddNewEncounter'))
const completedEncounter = React.lazy(() => import('./components/NewEncounter/CompletedEncounter'))
const NewPatient = React.lazy(() => import('./views/pages/newPatient/NewPatient'))
const UserNameEntry = React.lazy(() => import('./views/pages/resetPassword/UserNameEntry'))
const VerificationCode = React.lazy(() => import('./views/pages/resetPassword/VerificationCode'))
const ConfirmPassword = React.lazy(() => import('./views/pages/resetPassword/ConfirmPassword'))
const changePassword = React.lazy(() => import('./views/pages/resetPassword/ChangePassword'))
const SuccessPassword = React.lazy(() => import('./views/pages/resetPassword/SuccessPasswordReset'))
const selectPractice = React.lazy(() => import('./views/pages/Practice/Practice'))
const selectProvider = React.lazy(() => import('./views/pages/Provider/Provider'))
const patientsList = React.lazy(() => import('./views/pages/PatientList/PatientListScreen'))
const PatientDetails = React.lazy(() => import('./views/pages/PatientDetails/PatientDetails'))
const MFALogin = React.lazy(() => import('./views/pages/MFA/MFALogin'))
const OTPVerify = React.lazy(() => import('./views/pages/OtpVerify/OtpVerify'))
const PracticeIq = React.lazy(() => import('./views/pages/PracticeIQ/PracticeIq'))
const SuccessCheckout = React.lazy(() => import('./views/pages/stripe/SuccessCheckout'))
const CancelledCheckout = React.lazy(() => import('./views/pages/stripe/CancelledCheckout'))

const routes = [
  { path: '/', exact: true, name: 'Home' }, // seems to be unused
  { path: '/dashboard', name: 'Dashboard', element: Dashboard },

  { path: '/census', name: 'Census', element: CensusScreen, exact: true },
  { path: '/encounters', name: 'Encounters', element: EncountersScreen, exact: true },
  { path: '/newEncounter', name: 'New Encounter', element: newEncounter, exact: true },
  {
    path: '/completedEncounter/:id',
    name: 'Completed Encounter',
    element: completedEncounter,
    exact: true,
  },
  { path: '/patient/:id', name: 'New Patient', element: NewPatient, exact: true },
  { path: '/patient', name: 'New Patient', element: NewPatient, exact: true },
  { path: '/resetPassword/userName', name: 'Reset Password', element: UserNameEntry, exact: true },
  {
    path: '/resetPassword/changePassword',
    name: 'Change Password',
    element: changePassword,
    exact: true,
  },

  { path: '/providerHold', name: 'Provider Hold', element: ProviderHoldScreen, exact: true },
  { path: '/progressnote/:id', name: 'Provider Hold', element: progressNote, exact: true },

  {
    path: '/resetPassword/verificationCode',
    name: 'Reset Password',
    element: VerificationCode,
    exact: true,
  },
  {
    path: '/resetPassword/confirmpassword',
    name: 'Reset Password',
    element: ConfirmPassword,
    exact: true,
  },
  {
    path: '/resetPassword/successpassword',
    name: 'Reset Password',
    element: SuccessPassword,
    exact: true,
  },
  { path: '/selectPractice', name: 'Practice,', element: selectPractice, exact: true },
  { path: '/selectProvider', name: 'Provider,', element: selectProvider, exact: true },
  {
    path: '/encounter',
    name: 'New Encounter List',
    element: patientsList,
    exact: true,
  },
  {
    path: '/patientList',
    name: 'Patient List',
    element: patientsList,
    exact: true,
  },
  { path: '/MFALogin', name: 'MFA Login', element: MFALogin, exact: true },
  { path: '/OTPVerify', name: 'OTP Verify', element: OTPVerify, exact: true },
  { path: '/patientdetails/:id', name: 'Patient Details', element: PatientDetails, exact: true },
  { path: '/patientdetails', name: 'Patient Details', element: PatientDetails, exact: true },
  { path: '/practiceIq', name: 'PracticeIq', element: PracticeIq, exact: true },
  { path: '/messages', name: 'Messages', element: Message, exact: true },
  {
    path: '/stripe/checkout_success',
    name: 'Checkout successful',
    element: SuccessCheckout,
    exact: true,
  },
  {
    path: '/stripe/checkout_cancelled',
    name: 'Checkout cancelled',
    element: CancelledCheckout,
    exact: true,
  },
]

export const sidePanelFreeRoutes = [
  '/selectPractice',
  '/selectProvider',
  '/MFALogin',
  '/OTPVerify',
  '/resetPassword/userName',
  '/resetPassword/verificationCode',
  '/resetPassword/confirmpassword',
  '/resetPassword/successpassword',
  '/resetPassword/changePassword',
  '/stripe/checkout_success',
  '/stripe/checkout_cancelled',
]

export default routes
